export default "/assets/images/mila-filters-boxes.9aebbef8c537f76c.webp";